let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7EmV4")).then(() => parcelRequire('02f8q'));